<template>
  <div class="overflow-auto w-full flex flex-col h-full">
    <userEditModal
      v-if="selected"
      :isShip="true"
      :rowId="rowId"
      :orderNo="orderNo"
      :vehicle="selected"
      @refresh="getAll"
      :activeSpot="activeSpot"
    />
    <addModal
      :orderNo="orderNo"
      :rowId="rowId"
      :orderItem="order"
      :totalRemainingTonnage="totalRemainingTonnage"
      @refresh="() => ($emit('refresh', true), getAll())"
    />
    <piratedriverModal :item="order" :load="load" @submit="handleAddPirateDriver" />
    <!-- Manuel araç atama modalı -->
    <assignVehicleModal
      :rowId="rowId"
      :vehicle="selectedVehicle"
      :orders="orders"
      @refresh="getAll"
    />
    <!-- Toplu araç atama modalı -->
    <bulkAssignModal
      :rowId="rowId"
      :selectedVehicleIds="selectedVehicles"
      :vehicles="getSelectedVehicles()"
      :orders="orders"
      @refresh="getAll"
      @clearSelection="selectedVehicles = []"
    />

    <!-- Filtre butonları ve toplu atama butonu -->
    <div class="w-full items-center md:flex space-y-2 my-3">
      <div
        class="md:flex items-center md:justify-start justify-between w-full md:w-3/5 px-4 md:space-x-2 md:space-y-0 space-x-0 space-y-2"
      >
        <button
          @click="filterState = 'assigned'"
          :class="[
            'px-3 py-1 rounded text-sm md:w-auto w-full',
            filterState === 'assigned'
              ? 'bg-red-600 text-white'
              : 'bg-gray-200 dark:bg-gray-700',
          ]"
        >
          <div class="flex items-center">
            <span>Görevli Araçlar</span>
            <div
              v-if="counts.assigned"
              class="ml-2 px-2 py-0.5 bg-green-600 text-white text-xs font-bold rounded-lg shadow-md"
            >
              {{ counts.assigned }}
            </div>
          </div>
        </button>
        <button
          @click="filterState = 'available'"
          :class="[
            'px-3 py-1 rounded text-sm md:w-auto w-full',
            filterState === 'available'
              ? 'bg-red-600 text-white'
              : 'bg-gray-200 dark:bg-gray-700',
          ]"
        >
          <div class="flex items-center">
            <span>Uygun Araçlar</span>
            <div
              v-if="counts.available"
              class="ml-2 px-2 py-0.5 bg-blue-600 text-white text-xs font-bold rounded-lg shadow-md"
            >
              {{ counts.available }}
            </div>
          </div>
        </button>
        <button
          @click="filterState = 'deleted'"
          :class="[
            'px-3 py-1 rounded text-sm md:w-auto w-full',
            filterState === 'deleted'
              ? 'bg-red-600 text-white'
              : 'bg-gray-200 dark:bg-gray-700',
          ]"
        >
          <div class="flex items-center">
            <span>Silinen Ve Görevi Kabul Etmeyen Araçlar</span>
            <div
              v-if="counts.deleted"
              class="ml-2 px-2 py-0.5 bg-red-600 text-white text-xs font-bold rounded-lg shadow-md"
            >
              {{ counts.deleted }}
            </div>
          </div>
        </button>
      </div>

      <button
        v-if="isManualMode && selectedVehicles.length > 0 && filterState === 'available'"
        @click="openBulkAssignModal()"
        class="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
      >
        {{ selectedVehicles.length }} Aracı Görevlendir
      </button>

      <!-- Sipariş filtresi - sadece görevli araçlar sekmesinde göster -->
      <div v-if="filterState === 'assigned'" class="w-full md:w-2/5 px-4">
        <select
          v-model="orderFilter"
          @change="handleOrderFilterChange"
          class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-300"
        >
          <option value="">Tüm Siparişler</option>
          <option v-for="order in orders" :key="order.id" :value="order.orderNo">
            {{ order.orderNo }} - {{ order.orderName }}
          </option>
        </select>
      </div>
    </div>

    <div class="w-full items-center md:flex space-y-2 my-3">
      <div
        class="md:flex items-center w-full md:w-3/5 px-4 md:space-x-2 md:space-y-0 space-x-0 space-y-2"
      >
        <button
          @click="openNewVehicleModal"
          class="text-center"
          :disabled="isDisabled"
          :class="isDisabled ? 'btn-disabled' : 'btn-add-vehicle'"
        >
          <i class="fas fa-plus"></i> Yeni Araç
        </button>
        <button
          @click="openNewPirateVehicleModal"
          class="text-center"
          :disabled="isDisabled"
          :class="isDisabled ? 'btn-disabled' : 'btn-add-vehicle-pirate'"
        >
          <i class="fas fa-plus"></i> Korsan Araç Ekle
        </button>
      </div>
      <div
        class="md:flex items-center w-full md:w-3/5 px-4 md:space-x-2 md:space-y-0 space-y-2"
      >
        <searchInput v-model="search" @searcing="handleSearch" inputClass="w-full  " />
      </div>
    </div>
    <div class="h-3/6 overflow-auto w-full px-4">
      <table
        class="w-full divide-y divide-gray-200 shadow border-b overflow-y-scroll border-gray-200 bg-gray-200 dark:bg-gray-900 sm:rounded-lg"
      >
        <thead class="bg-white border-black border-dotted border-b-2 border-opacity-20">
          <tr>
            <th
              v-if="isManualMode && filterState === 'available'"
              scope="col"
              class="table-th text-center w-10"
            >
              <input
                type="checkbox"
                :checked="selectAll"
                @change="toggleSelectAll"
                class="h-4 w-4 text-red-600"
              />
            </th>
            <th scope="col" class="table-th text-center">#</th>
            <th
              scope="col"
              class="table-th text-left border-r border-opacity-20"
              style="min-width: 200px !important"
            >
              Araç
            </th>

            <th
              scope="col"
              class="table-th text-left border-r border-opacity-20"
              style="min-width: 100px !important"
            >
              Dorse
            </th>
            <th
              scope="col"
              class="table-th text-left border-r border-opacity-20"
              style="min-width: 160px !important"
            >
              Sürücü
            </th>
            <th
              scope="col"
              class="table-th text-center border-r border-opacity-20"
              style="min-width: 80px !important"
              title="Sefer Sayısı"
            >
              Sefer
            </th>
            <th
              scope="col"
              class="table-th text-left border-r border-opacity-20"
              style="min-width: 90px !important"
            >
              Mevcut İş
            </th>
            <th
              v-if="listType == `storage` && filterState === 'assigned'"
              class="table-th text-center border-r border-opacity-20"
            >
              Durdur/Başlat
            </th>
            <th
              scope="col"
              class="table-th border-r border-opacity-20"
              style="min-width: 150px !important"
            >
              Son Durum
            </th>

            <th scope="col" class="table-th text-left border-r border-opacity-20"></th>
          </tr>
        </thead>
        <tbody class="divide-y-2 divide-gray-500" style="background-color: #3a3a3a">
          <tr
            v-for="(item, index) in List"
            :key="item.id"
            :class="item?.isReject == 1 && item?.isDelete == 1 ? 'opacity-30' : ''"
          >
            <td
              v-if="isManualMode && filterState === 'available'"
              class="table-td text-center border-r border-opacity-20"
            >
              <input
                type="checkbox"
                v-model="selectedVehicles"
                :value="item.id"
                :disabled="
                  !(
                    filterState === 'available' ||
                    ((!item.stateId || item.stateId === 0) && item.isStopped === 2)
                  ) ||
                  (item?.isReject == 1 && item?.isDelete == 1)
                "
                class="h-4 w-4 text-red-600"
              />
            </td>
            <td class="table-td text-center border-r border-opacity-20">
              {{ index + 1 + currentPage * 20 }}
            </td>
            <td class="table-td border-r border-opacity-20">
              <div class="flex justify-between items-center">
                <p>{{ item.plaque }}</p>
                <span
                  class="text-white text-xs inline-block font-extralight"
                  v-if="item.isCustom == 1 || item.isReject == 1"
                >
                  <div v-if="item?.isReject == 1" class="bg-red-600 px-2 rounded-xl">
                    {{ item?.changeRejectId == 1 ? "Reddetti" : "İptal Edildi" }}
                  </div>
                  <div v-else>
                    <div class="flex items-center justify-between">
                      <div class="ml-2 flex items-center justify-between">
                        <span
                          @click="
                            swalBox(
                              'info',
                              'BİLGİ',
                              item.isPirateDriver == 1
                                ? 'Firma dışından bağımsız bir sürücüye (korsan araç) atandı.'
                                : 'Operasyon personeli, önerilen araçlar yerine bu aracı manuel olarak seçti.'
                            )
                          "
                          style="font-size: 11px"
                          class="px-2 rounded-xl cursor-pointer select-none text-white inline-block font-extralight whitespace-nowrap"
                          :class="
                            item.isPirateDriver == 1 ? 'bg-yellow-600' : 'bg-red-600'
                          "
                          v-if="item.isCustom == 1 || item.isPirateDriver == 1"
                          :title="
                            item.isPirateDriver == 1
                              ? 'Firma dışından bağımsız bir sürücüye (korsan araç) atandı'
                              : 'Operasyon personeli, önerilen araçlar yerine bu aracı manuel olarak seçti'
                          "
                        >
                          <i class="fas fa-info-circle"></i>
                          {{ item.isPirateDriver == 1 ? "Korsan Atama" : "Manuel Atama" }}
                        </span>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </td>
            <td class="table-td border-r border-opacity-20">
              <p class="p-1">{{ item.dorse }}</p>
            </td>
            <td class="table-td border-r border-opacity-20">
              <p>{{ item.NAME }}</p>
            </td>
            <td class="table-td border-r border-opacity-20 font-bold text-center">
              <p>{{ item.transitionCount }}</p>
            </td>
            <td class="table-td border-r border-opacity-20 font-bold text-center">
              <p>
                {{
                  item.isReleasedFromShip == 1
                    ? "Serbest"
                    : item.isStart == 3
                    ? "Yok"
                    : "#" + item.orderNo
                }}
              </p>
            </td>
            <td
              v-if="listType == `storage` && filterState === 'assigned'"
              class="table-td border-r border-opacity-20 font-bold text-center"
            >
              <asyncBtn
                :disabled="isDisabled || isOrderStopped"
                :loadState="setLoad"
                @click="stopedControl(item)"
                :text="item.isStopped == 2 ? 'Durdur' : 'Başlat'"
                icon=""
                size="py-1 "
                :containerClass="
                  item.isStopped === 1
                    ? isDisabled
                      ? 'bg-green-800 w-40'
                      : 'bg-green-700 hover:bg-green-500 w-40'
                    : 'w-40'
                "
              />
            </td>
            <td class="table-td border-r border-opacity-20 text-left text-xs">
              <div
                v-if="!(item?.isReject == 1 && item?.isDelete == 1)"
                class="flex items-center"
              >
                <span
                  v-if="item.stateName && item.stateId < 8"
                  class="mx-auto"
                  :class="{
                    'bg-green-500 text-white px-2 py-1 rounded':
                      item.stateId >= 4 && item.stateId < 8,
                    'bg-yellow-500 text-white px-2 py-1 rounded':
                      item.stateId >= 1 && item.stateId < 4,
                    'bg-blue-500 text-white px-2 py-1 rounded': item.stateId === 8,
                    'bg-red-500 text-white px-2 py-1 rounded': item.stateId === 9,
                  }"
                >
                  {{ item.stateName }}
                </span>
                <span v-else class="text-gray-500"> Görevlendirilmedi </span>

                <!-- Filtre durumlarını göster -->
                <span
                  v-if="filterState === 'available' && item.isReleasedFromShip == 1"
                  class="ml-2 bg-green-600 text-white px-2 py-1 rounded text-xs"
                >
                  Atanabilir
                </span>
              </div>
              <div v-else class="text-red-500">Silindi</div>
            </td>
            <td class="table-td border-r border-opacity-20">
              <!-- Aktif veya kullanılabilir araçlar için işlemler -->
              <div
                v-if="filterState === 'assigned' || filterState === 'available'"
                class="flex items-center justify-center p-1"
              >
                <button
                  :class="
                    isDisabled
                      ? 'text-white border rounded px-2 py-1 border-opacity-30 bg-opacity-30 text-opacity-30 mr-2 cursor-default'
                      : 'process-btn mr-2'
                  "
                  @click="userEditModal(item)"
                  :title="
                    isDisabled ? 'Bu işlem şu anda yapılamaz' : 'Araç bilgilerini düzenle'
                  "
                >
                  <i class="fas fa-pen"></i>
                </button>

                <!-- Manuel atama butonu -->

                <button
                  v-if="
                    isManualMode &&
                    orders.some(o => o.tonnage > 0 && o.isCopmletedOrder !== 1) &&
                    (filterState === 'available' ||
                      ((!item.stateId || item.stateId === 0 || item.stateId > 7) &&
                        item.isStopped === 2))
                  "
                  class="process-btn mr-2 bg-green-600"
                  @click="openAssignModal(item)"
                  title="Araçı Siparişe Ata"
                >
                  <i class="fas fa-share"></i>
                </button>

                <!-- Tur tamamlama butonu -->
                <button
                  v-if="item.stateId >= 4 && item.stateId < 8"
                  class="process-btn mr-2 bg-blue-600"
                  @click="completeTour(item)"
                  title="Turu Tamamla"
                >
                  <i class="fas fa-check"></i>
                </button>

                <button
                  :class="
                    isDisabled
                      ? 'text-white border rounded px-2 py-1 border-opacity-30 bg-opacity-30 text-opacity-30'
                      : 'process-btn'
                  "
                  :disabled="isDisabled || (item?.isReject == 1 && item?.isDelete == 1)"
                  @click="deleteItem(item)"
                  :title="
                    isDisabled ? 'Bu işlem şu anda yapılamaz' : 'Aracı planlamadan çıkar'
                  "
                >
                  <i class="fas fa-trash"></i>
                </button>
              </div>

              <!-- Silinen ve iptal edilen araçlar için durum bilgisi -->
              <div v-else>
                <span v-if="filterState === 'deleted'" class="text-red-500 font-medium"
                  >Silindi</span
                >
                <span
                  v-else-if="filterState === 'rejected'"
                  class="text-yellow-500 font-medium"
                  >İptal Edildi</span
                >
              </div>
            </td>
          </tr>
          <tableLoader :load="load" :length="List.length" colspan="10" />
        </tbody>
      </table>
    </div>
    <div class="px-4 h-1/6 flex items-center">
      <PaginationComponents
        v-if="totalCount > 0"
        :totalRowCount="totalCount"
        :pageCount="pageCount"
        :currentPage="currentPage + 1"
        @changePage="(r) => (currentPage = r - 1)"
      />
    </div>
  </div>
</template>

<script>
//Npm
import moment from "moment";

//Global Components
import tableLoader from "@/components/general/table-loader.vue";
import PaginationComponents from "@/components/general/pagination.vue";
import userEditModal from "@/components/modals/userEditModal/index.vue";
import searchInput from "@/components/general/search-input.vue";
import asyncBtn from "@/components/general/asyncBtn.vue";
import piratedriverModal from "@/components/modals/addPriatedDriverModal/piratedriver.modal.vue";
// local components
import addModal from "../add.vue";
import assignVehicleModal from "./assignVehicleModal.vue";
import bulkAssignModal from "./bulkAssignModal.vue";

//networking
import axios from "axios";
import { bulkShipPlanning } from "@/networking/urlmanager";
export default {
  props: ["rowId", "isDisabled", "orderNo", "order", "isManualMode", "listType"],
  components: {
    tableLoader,
    PaginationComponents,
    userEditModal,
    searchInput,
    addModal,
    piratedriverModal,
    asyncBtn,
    assignVehicleModal,
    bulkAssignModal,
  },
  data() {
    return {
      // activeAxios: 2,
      // active: 1,
      load: false,
      List: [],
      selected: undefined,
      selectedVehicle: null,
      totalCount: 0,
      pageCount: 0,
      currentPage: 0,
      search: "",
      isAllStopped: 1,
      newisStopped: 2,
      setLoad: false,
      note: "",
      selectedOrder: "",
      orders: [],
      filterState: "assigned", // Filtre durumu için yeni değişken
      selectedVehicles: [], // Seçili araçların ID'lerini tutacak dizi
      selectAll: false, // Tümünü seç kontrolü için
      orderFilter: "", // Sipariş filtreleme için
      counts: {
        assigned: 0,
        available: 0,
        deleted: 0,
        rejected: 0,
      }, // Araç sayıları
    };
  },
  methods: {
    openNewVehicleModal() {
      this.$modal.show("add-vehicle-modal");
    },
    openNewPirateVehicleModal() {
      this.$modal.show("pirate-driver-plan-modal");
    },

    // Manuel araç atama modalını aç
    openAssignModal(item) {
      this.selectedVehicle = item;
      this.$modal.show("assign-vehicle-modal");
    },

    // Toplu atama modalını aç
    openBulkAssignModal() {
      this.$modal.show("bulk-assign-vehicle-modal");
    },

    // Seçili araçların tam bilgilerini getir
    getSelectedVehicles() {
      return this.List.filter((item) => this.selectedVehicles.includes(item.id));
    },

    // Sipariş filtresini değiştirme işlemi
    handleOrderFilterChange() {
      this.currentPage = 0;
      this.getAll();
    },

    // Tüm araçları seç/kaldır
    toggleSelectAll() {
      this.selectAll = !this.selectAll;
      this.selectedVehicles = this.selectAll
        ? this.List.filter(
            (item) =>
              (this.filterState === "available" || !item.stateId || item.stateId === 0) &&
              item.isStopped === 2 &&
              !(item?.isReject == 1 && item?.isDelete == 1)
          ).map((item) => item.id)
        : [];
    },

    // Tur tamamlama fonksiyonu
    completeTour(item) {
      // Kullanıcıya onay sor
      this.swalBox(
        "warning",
        "Araç Turu Tamamlama",
        `${item.plaque} plakalı aracın mevcut turunu tamamlamak ve yeniden atanabilir duruma getirmek istediğinizden emin misiniz?`,
        true,
        "Evet, Tamamla",
        "Vazgeç"
      ).then((acc) => {
        if (acc.isConfirmed) {
          // Tur tamamlama isteği gönder
          axios
            .post(
              bulkShipPlanning.completeTour,
              {
                vehicleId: item.id,
                shipId: this.rowId,
              },
              {
                headers: {
                  Authorization: "Bareer " + this.$store.state.userData.token,
                },
              }
            )
            .then(() => {
              this.swalBox(
                "success",
                this.$t("general.successTitle"),
                "Araç turu başarıyla tamamlandı ve araç yeniden atanabilir duruma getirildi.",
                false,
                this.$t("general.OkayTitle")
              );
              this.getAll();
            })
            .catch((err) => {
              this.errorBox(err.response);
            });
        }
      });
    },
    handleSearch() {
      this.currentPage = 0;
      this.getAll();
    },
    stopControl() {
      this.isAllStopped = 1;
      this.type = 2;
      this.orderStatus();
    },
    startControl() {
      this.isAllStopped = 2;
      this.type = 2;
      this.orderStatus();
    },
    stopedControl(item) {
      const actionText = item.isStopped == 2 ? 'durdurmak' : 'başlatmak';
      const actionTitle = item.isStopped == 2 ? 'Araç Durdurma' : 'Araç Başlatma';

      this.swalBox(
        "warning",
        actionTitle,
        `${item.plaque} plakalı aracı ${actionText} istediğinize emin misiniz?`,
        true,
        this.$t("general.confirmText"),
        this.$t("general.rejectText")
      ).then((acc) => {
        if (acc.isConfirmed) {
          if (item.isStopped == 2) {
            this.type = 1;
            this.newisStopped = 1;
            this.isAllStopped = 0;
            this.orderStatus(item);
          } else {
            this.newisStopped = 2;
            this.type = 1;
            this.isAllStopped = 0;
            this.orderStatus(item);
          }
        }
      });
    },
    orderStatus(item) {
      this.setLoad = true;
      let newItem = [item];
      let noteInput;
      let orderSelect;
      if (
        item.isStopped == 2 &&
        item.workingVehicles <= Number(item.minShipVehicleCount)
      ) {
        this.$swal
          .fire({
            icon: "warning",
            title: this.$t("general.warningTitle"),
            text: "Aracı durdurmak istediğimize emin misiniz",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: this.$t("general.confirmText"),
            cancelButtonText: this.$t("general.rejectText"),
            customClass: {
              popup: "w-1/2",
            },
            html: `<div class="flex flex-col items-center">
                <span class="w-full">Aracı durdurmak istediğimize emin misiniz</span>
                <select id="order" class="swal2-select w-2/3 border-2 rounded-lg">
                  <option value="">Seçiniz</option>
                  ${this.orders
                    .map(
                      (option) =>
                        `<option value="${option.id}">${option.orderName}</option>`
                    )
                    .join("")}
                </select>
                <input id="note" class="swal2-input w-2/3" placeholder="Açıklama">
              </div>`,
            didOpen: () => {
              const popup = this.$swal.getPopup();
              noteInput = popup.querySelector("#note");
              orderSelect = popup.querySelector("#order");
              noteInput.onkeyup = (event) => event.key === "Enter" && Swal.clickConfirm();
              orderSelect.onkeyup = (event) =>
                event.key === "Enter" && Swal.clickConfirm();
            },
            preConfirm: () => {
              this.note = noteInput.value;
              this.selectedOrder = orderSelect.value;
            },
          })
          .then((acc) => {
            if (acc.isConfirmed) {
              const params = {
                isStopped: this.newisStopped,
                isAllStopped: this.isAllStopped,
                shipId: this.rowId,
                // orderNo: this.orderNo,
                list: this.type == 1 ? newItem : this.List,
                bulkId: this.selectedOrder ? this.selectedOrder : false,
                note: this.note ? this.note : false,
                isCritical: true,
              };
              this.handleOrderStatus(params);
            } else {
              this.setLoad = false;
            }
          });
      } else {
        const params = {
          isStopped: this.newisStopped,
          isAllStopped: this.isAllStopped,
          shipId: this.rowId,
          list: this.type == 1 ? newItem : this.List,
          isCritical: false,
        };
        this.handleOrderStatus(params);
      }
    },
    userEditModal(item) {
      this.activeSpot = false;
      this.selected = item.plaque;

      setTimeout(() => {
        this.$modal.show("ueserEdit-modal");
      }, 50);
    },
    handleOrderStatus(params) {
      axios
        .post(
          bulkShipPlanning.vehicleSet,
          { params },
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then((res) => {
          this.swalBox(
            "success",
            this.$t("general.successTitle"),
            "",
            false,
            this.$t("general.OkayTitle")
          );
          this.setLoad = false;
          this.getAll();
        })
        .catch((err) => {
          this.errorBox(err.response);
          this.setLoad = false;
        });
    },
    getAll() {
      this.List = [];
      this.load = true;

      // URL parametrelerini oluştur
      let queryParams = {
        rowId: this.rowId,
        page: this.currentPage,
        search: this.search || "",
        filterState: this.filterState || "assigned",
      };

      // Sipariş filtresi sadece görevli araçlar sekmesinde kullanılır
      if (this.filterState === "assigned" && this.orderFilter) {
        queryParams.orderNo = this.orderFilter;
      }

      const params = new URLSearchParams(queryParams);

      axios
        .get(`${bulkShipPlanning.vehiclesAll}?${params.toString()}`, {
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          },
        })
        .then((res) => {
          this.List = res.data.data.detail;
          this.totalCount = res.data.data.totalCount;
          this.pageCount = res.data.data.pageCount;

          // Araç sayılarını güncelle (API'den geliyorsa)
          if (res.data.data.counts) {
            this.counts = res.data.data.counts;
            // Üst bileşene sayıları bildir
            this.$emit("updateCounts", this.counts);
          }
        })
        .catch((err) => {
          this.errorBox(err.response);
        })
        .finally(() => {
          this.load = false;
        });
    },
    deleteItem(item) {
      if (
        (item.stateId == 4 && item.isUploadStarted == 1) ||
        (item.stateId > 4 && item.stateId < 8)
      ) {
        this.swalBox(
          "warning",
          this.$t("general.warningTitle"),
          ` ${item.plaque} Plakalı aracın üzerinde yük olduğu için silemezsiniz.`,
          false,
          this.$t("general.OkayTitle")
        );
        return;
      }
      let noteInput;
      let orderSelect;
      if (item.workingVehicles <= Number(item.minShipVehicleCount)) {
        const warningText =
          item.workingVehicles === Number(item.minShipVehicleCount)
            ? "Aracın silinmesi halinde Gemi için önerilen araç sayısının altına düşeceksiniz yine de devam etmek istiyorsanız, Aşağıdaki siparişlerden hangisi için önerilen araç sayısını 1 eksiltmek istediğinizi seçiniz. "
            : "Gemi için önerilen araç sayısının altındasınız yine de devam etmek istiyorsanız, Aşağıdaki siparişlerden hangisi için önerilen araç sayısını 1 eksiltmek istediğinizi seçiniz.";
        this.$swal
          .fire({
            icon: "warning",
            title: this.$t("general.warningTitle"),
            text: warningText,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: this.$t("general.confirmText"),
            cancelButtonText: this.$t("general.rejectText"),
            customClass: {
              popup: "w-1/2",
            },
            html: `<div class="flex flex-col items-center">
                <span class="w-full">${warningText}</span>
                <select id="order" class="swal2-select w-2/3 border-2 rounded-lg">
                  <option value="">Seçiniz</option>
                  ${this.orders
                    .map(
                      (option) =>
                        `<option value="${option.id}">${option.orderName}</option>`
                    )
                    .join("")}
                </select>
                <input id="note" class="swal2-input w-2/3" placeholder="Açıklama">
              </div>`,
            didOpen: () => {
              const popup = this.$swal.getPopup();
              noteInput = popup.querySelector("#note");
              orderSelect = popup.querySelector("#order");
              noteInput.onkeyup = (event) => event.key === "Enter" && Swal.clickConfirm();
              orderSelect.onkeyup = (event) =>
                event.key === "Enter" && Swal.clickConfirm();
            },
            preConfirm: () => {
              this.note = noteInput.value;
              this.selectedOrder = orderSelect.value;
            },
          })
          .then((acc) => {
            if (acc.isConfirmed) {
              const params = {
                rowId: item.id,
                plaque: item.plaque.toString(),
                bulkId: Number(this.selectedOrder) ? Number(this.selectedOrder) : false,
                shipId: item.shipId,
                orderNo: this.orderNo,
                note: this.note ? this.note : false,
                isCritical: true,
                driverTC: item.driverTC,
              };
              this.handleDelete(params);
            }
          });
      } else {
        this.swalBox(
          "warning",
          this.$t("general.warningTitle"),
          "Aracı planlamadan çıkarmak istediğinize emin misiniz ?",
          true,
          this.$t("general.confirmText"),
          this.$t("general.rejectText")
        ).then((acc) => {
          if (acc.isConfirmed) {
            const params = {
              rowId: item.id,
              plaque: item.plaque.toString(),
              bulkId: 0, // bağlı olduğu geminin idsini döndürt
              shipId: item.shipId,
              orderNo: this.orderNo,
              isCritical: false,
              driverTC: item.driverTC,
            };
            this.handleDelete(params);
          }
        });
      }
    },
    getOrderList() {
      this.orders = [];
      this.load = true;
      axios
        .get(bulkShipPlanning.orderdersgetAll + "?shipId=" + this.rowId, {
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          },
        })
        .then((res) => {
          this.orders = res.data.data.detail;
          this.$emit("orderList", this.List);
        })
        .catch((err) => {
          this.errorBox(err.response);
        })
        .finally(() => {
          this.load = false;
        });
    },
    handleDelete(params) {
      axios
        .post(
          bulkShipPlanning.vehicleDelete,
          { params },
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then(() => {
          this.swalBox(
            "success",
            this.$t("general.successTitle"),
            "",
            false,
            this.$t("general.OkayTitle")
          );
          this.$emit("refresh", true);
          this.getAll();
        })
        .catch((err) => {
          this.errorBox(err.response);
        });
    },
    handleAddPirateDriver(params) {
      this.load = true;
      axios
        .post(
          bulkShipPlanning.vehicleAdd,
          {
            shipId: this.rowId,
            vehicleList: params,
            isPirateDriver: 1,
          },
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then(() => {
          this.swalBox(
            "success",
            this.$t("general.successTitle"),
            "",
            false,
            this.$t("general.OkayTitle")
          );
          this.$modal.hide("pirate-driver-plan-modal");
        })
        .catch((err) => {
          this.errorBox(err.response);
        })
        .finally(() => {
          this.load = false;
          this.getAll();
        });
    },
  },

  computed: {
    totalRemainingTonnage() {
      if (!this.orders || this.orders.length === 0) return 0;
      return this.orders.reduce((sum, order) => {
        const remaining = Number(order.tonnage || 0) - Number(order.receivedTonnage || 0);
        return sum + Math.max(0, remaining);
      }, 0);
    },
  },
  created() {
    this.getAll();
    this.getOrderList();
  },
  watch: {
    currentPage() {
      this.getAll();
    },
    filterState() {
      this.currentPage = 0;
      this.selectedVehicles = [];
      this.selectAll = false;
      this.getAll();
    },
    orderFilter() {
      this.currentPage = 0;
      this.getAll();
    },
  },
  filters: {
    dateFormat(val) {
      return moment(val).format("LLLL");
    },
  },
};
</script>
